import { FormHelperText } from '@mui/material';
import { TEXT_FIELD_CONSTANCE } from '../ActionEvaluationDialog/constants';

interface TextFieldCharactersCounterProps {
  text: string;
  limit?: number;
}

export const TextFieldCharactersCounter = ({
  text,
  limit = TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT,
}: TextFieldCharactersCounterProps) => {
  return (
    <FormHelperText
      sx={{
        fontSize: (theme) => theme.typography.body1,
        textAlign: 'end',
      }}
    >
      {text.length || 0}/{limit}
    </FormHelperText>
  );
};
